'use client'
import useIncludeAirportsManager from '@/src/hooks/srp/includeAirportsManager'
import useMulticityJourneyLabels from '@/src/hooks/srp/multicity/useMulticityJourneyLabels'
import useSearchResults from '@/src/hooks/srp/useSearchResults'
import { useState } from 'react'
import MulticityJourneySegmentTabs from '../multicityJourneySegmentTabs'
import { IncludeAirportsFilter } from './includeAirportsFilter'

const IncludeAirportsFilterWrapper = () => {
    const [journeyIndex, setJourneyIndex] = useState(0)
    const { isMulticity, journeyCount } = useSearchResults()
    const journeys = useMulticityJourneyLabels()
    const filterJourneyIndex = isMulticity ? journeyIndex : 0
    const { title, nbAirportGroups, handleSelectToggle, handleReset, handleResetAllJourneys, shouldShowReset, shouldShowResetForAllJourneys, hasAnyOptions } =
        useIncludeAirportsManager(filterJourneyIndex)

    if (!hasAnyOptions) return null

    return (
        <IncludeAirportsFilter
            groups={nbAirportGroups}
            onAirportSelect={handleSelectToggle}
            onReset={isMulticity ? handleResetAllJourneys : handleReset}
            shouldShowReset={isMulticity ? shouldShowResetForAllJourneys : shouldShowReset}
            title={title}
            journeyTabs={
                isMulticity && journeyCount > 1 ? (
                    <MulticityJourneySegmentTabs
                        journeys={journeys}
                        selectedIndex={journeyIndex}
                        onSelect={setJourneyIndex}
                    />
                ) : null
            }
        />
    )
}

export { IncludeAirportsFilterWrapper }
export default IncludeAirportsFilterWrapper
